<template>
    <div class="single-select-list-wrapper">
        <selectable-item
            v-for="option in paginatedList"
            :key="option.id"
            :label="option.name"
            :is-selected="isOptionSelected(option)"
            :un-checkable="true"
            @selection-change="handleSelectionChange(option)">
        </selectable-item>
        <div class="multi-select-list-tool" v-show="options.length > itemsPerPage">
            <list-pagination :mappingsPerPage="itemsPerPage"
                            :targetList="filteredList"
                            @results="handlePaginatedListResults"
                            class="pagination-spacing"
                            >
            </list-pagination>
            <list-filter :searchConfig="{targetKeys: ['name'], targetlistType: 'deep'}"
                        :targetList="options"
                        @results="handleFilterUpdate">
            </list-filter>
        </div>
    </div>
</template>

<script>
import SelectableItem from './selectable-item.vue';
import ListFilter from '../generic/list-filter.vue';
import ListPagination from '../generic/list-pagination';

// the selectedValues array is an array of options ids. It is a flat array. Just numbers. The indexes in the array represent
// which elements of the array are selected.

export default {
    name: 'multi-select-list',
    components: {
        'selectable-item': SelectableItem,
        'list-filter': ListFilter,
        'list-pagination': ListPagination,
    },
    props: {
        options: Array,
        selectedOptionIds: Array,
        itemsPerPage: {
            type: Number,
            default: 8
        }
    },
    data() {
        return {
            filteredList: this.options,
            paginatedList: [],
        }
    },
    computed: {},
    methods: {
        isOptionSelected(option) {
            let found = this.selectedOptionIds.filter((el) => {
                return parseInt(el, 10) === parseInt(option.id, 10);
            })
            return found.length > 0;
        },
        handleSelectionChange(option) {
            this.$emit('selection-change', option);
        },
        handleFilterUpdate(filteredList) {
            this.filteredList = filteredList;
        },
        handlePaginatedListResults(result) {
            this.paginatedList = result;
        }
    }
};
</script>

<style>
    .pagination-spacing {
        margin-bottom: 5px;
    }
    .single-select-list-wrapper {
        margin-left: 20px;
        margin-top: 5px;
    }
    .multi-select-list-tool {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin: 10px 10px 0 0;
    }
</style>